
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import FaqSection from "@/components/FaqSection.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb,
    FaqSection
  }
})
export default class businessSchool extends Vue {
  // FAQ 数据（与 seo.ts 中 FAQ JSON-LD 对应）
  faqList = [
    { question: "光华商学院有哪些培训服务？", answer: "提供企业内训、公开课、光华研修班等系统化培训服务。" },
    { question: "光华商学院的培训理念是什么？", answer: "追求实战、实操、实用、实效、实践，帮助企业少走弯路。" },
    { question: "光华商学院课程覆盖哪些领域？", answer: "涵盖战略、管理、营销、人力、财务、生产等企业经营全领域。" }
  ];
  get metaInfo() {
    return generateMetaInfo({
      title: "光华商学院 | 实战·实操·实用·实效·实践，助推企业高质量发展 - 光华赋能",
      description:
        "光华商学院追求实战、实操、实用、实效、实践，帮助企业实现少躺坑、少走弯路、少花冤枉钱。提供企业内训、公开课、光华研修班等系统化培训服务，用科学经营助推企业高质量发展。",
      keywords:
        "光华商学院,企业培训,实战培训,企业内训,公开课,研修班,管理培训,光华赋能",
      path: "/business-school",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "光华商学院" }
      ],
      jsonLd: getServiceJsonLd({
        name: "光华商学院",
        description:
          "提供企业内训、公开课、研修班等系统化企业培训服务，追求实战、实操、实用、实效、实践。",
        category: "企业商学院培训"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  List = [
    { title: "光华商学院", url: "" },
    { title: "光华商学院", url: "" }
  ];
  pic1 = "/img/22af09700dd3a7e724bca52542b8910b.png";
  pic2 = "/img/3508a595b05ce43cb2bd63d843c8205f.png";
  pic3 = "/img/62dc631e4e0dba09a53ce5e57f911f04.png";
  pic4 = "/img/a710014a6d2fcd25698f28f117e10603.png";
  pic5 = "/img/03a26bab69ce602cf12856ade0012a01.png";
  pic6 = "/img/287f90ab3604c022894102b9f5b0da91.png";
  pic7 = "/img/26c708144b61d2a81efbb7af500ab39d.png";
  pic8 = "/img/03fe1bafbad655bf20760f5d78e11e55.png";
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华商学院，公开课,企业内训，公开课，企业培训,公开课培训网,时代光华公开课"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训，线下课程，管理培训，公开课培训,新员工培训，股权咨询，体系课程，管理课程，销售课程，HR课程，HRBP，运营课程，团队，领导力，AI，人工智能，办公效率提升，训战营，主播，全域营销，必修课，选修课，集训，实战，实操，实用，实地，实在，学，练，考，评，赛，实战运营，项目管理，战略，绩效，绩效体系，人才管理，AI+组织技能，组织发展，管理创新，财务，，学院，总裁，管理，人力，运营，职场，财务，生成，制造，宏观经济，战略/变革，组织发展，招聘面试，高层管理，基层管理，中层管理，管理创新，市场营销，薪酬绩效，培训体系，项目研发，财务管理，劳动法，数智化制造，仓储物流，生产计划，税务筹划，预算管控，职业技能，PPT，EXCEL，WORD，办公Office系列,TTT，市场营销，线上流量，私域流量，业务团队，平台流量，采购供应链，质量管理，精益生产，降本增效，应收账款，现场管理，班组长"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
